import { apiClient } from '../../../shared/lib/http';

export async function getMyProfile() {
  const { data } = await apiClient.get('/users/me');
  return data;
}

export async function updateMyProfile(payload) {
  const { data } = await apiClient.put('/users/me', payload);
  return data;
}

export async function changeMyPassword(payload) {
  const { data } = await apiClient.put('/users/me/password', payload);
  return data;
}

export async function listUsers() {
  const { data } = await apiClient.get('/users');
  return data;
}

export async function createUser(payload) {
  const { data } = await apiClient.post('/users', payload);
  return data;
}

export async function updateUser(userId, payload) {
  const { data } = await apiClient.put(`/users/${userId}`, payload);
  return data;
}

export async function toggleUserEnabled(userId) {
  const { data } = await apiClient.delete(`/users/${userId}`);
  return data;
}
